import { api, type APIResponse } from "../config/api";

export type OnlineOrderStatus =
  | "new"
  | "confirmed"
  | "packed"
  | "shipped"
  | "delivered"
  | "cancelled";

export interface OnlineOrderSummary {
  id: number;
  orderNumber: string;
  status: OnlineOrderStatus;
  customerId: number;
  customerName: string;
  customerPhone: string;
  deliveryDetails: string;
  paymentMode: string;
  grandTotal: number;
  itemCount: number;
  branchId: number;
  salesId: number | null;
  invoiceNumber: string | null;
  remarks: string;
  confirmedAt: string | null;
  confirmedBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface OnlineOrderDetail extends OnlineOrderSummary {
  salesPayload?: Record<string, unknown>;
  salesItems?: Record<string, unknown>[];
}

export const ONLINE_ORDER_STATUS_FLOW: Record<
  OnlineOrderStatus,
  OnlineOrderStatus[]
> = {
  new: ["confirmed", "cancelled"],
  confirmed: ["packed"],
  packed: ["shipped"],
  shipped: ["delivered"],
  delivered: [],
  cancelled: [],
};

export const getOnlineOrders = async (status?: OnlineOrderStatus) => {
  const url = status
    ? `/onlineOrder/?status=${encodeURIComponent(status)}`
    : "/onlineOrder/";
  const response = await api().get<APIResponse<OnlineOrderSummary[]>>(url);
  return response.data;
};

export const getOnlineOrderById = async (id: number) => {
  const response = await api().get<APIResponse<OnlineOrderDetail>>(
    `/onlineOrder/?id=${id}`,
  );
  return response.data;
};

export const updateOnlineOrderStatus = async (
  id: number,
  status: OnlineOrderStatus,
) => {
  const response = await api().put<APIResponse<OnlineOrderSummary>>(
    `/onlineOrder/?id=${id}`,
    { status },
  );
  return response.data;
};
